const LowFrequencyLiveEmp = () =>
  import('@/views/main/live/lowFrequencyLiveEmp/LowFrequencyLiveEmp.vue')
export default {
  path: '/main/live/lowFrequencyLiveEmp',
  name: 'LowFrequencyLiveEmp',
  component: LowFrequencyLiveEmp
}
